import styled from 'styled-components';
import GreetingSection from '../../components/navbar/GreetingSection';
import { useTranslation } from 'react-i18next';
import './index.less';
import { InboxHeader } from './components/header';
import AccountList from './components/List';
import { Root } from 'all-in-one-shared-api/dist/apis/profile/useLifeUserProfile';
import { useState } from 'react';
const LifePageContainer = styled.div`
  margin: 0;
  dispay: flex;
`;
const LifeAccount = () => {
  const { t } = useTranslation();
  // const [messageFromChild, setMessageFromChild] = useState(''); // 父组件的状态
  // const handleMessageFromChild = (message: string) => {
  //   setMessageFromChild(message); // 更新父组件的状态
  // };
  const [avatarStatus, setAvatarStatus] = useState(false);
  const [profile, setProfile] = useState<Root>();
  const setStatus = () => {
    setAvatarStatus(true);
  };
  const setProfileDate = (data: Root) => {
    setProfile(data);
  };
  return (
    <LifePageContainer className="life_inbox_container">
      <GreetingSection pageName={t('life.lifeProfile.title')} showicon={true} />
      <InboxHeader
        avatarStatus={avatarStatus}
        sendStatus={() => {
          setAvatarStatus(false);
        }}
        sendProfileInfo={setProfileDate}
        // sendMessage={handleMessageFromChild} //父子组件传参
      />
      <AccountList sendStatus={setStatus} profile={profile}></AccountList>
    </LifePageContainer>
  );
};
export default LifeAccount;
